export const DEPLOYMENT_MODE = {
    PROD: 'prod',
    DEV: 'dev'
}